module.exports = __webpack_public_path__ + "media/audio48.cf4b8ac2.mp3";